
export default {
  name: 'RosterDetailListActions',
  props: {
    detail: {
      type: Boolean,
      default: () => false
    },
    detailTitle: {
      type: String,
      default: 'Lihat Detail'
    },
    manageOnline: {
      type: Boolean,
      default: () => false
    },
    manageOnlineTitle: {
      type: String,
      default: 'Atur Online'
    },
    manageSnack: {
      type: Boolean,
      default: () => false
    },
    manageSnackTitle: {
      type: String,
      default: 'Atur Snack'
    }
  }
}
